import { useContext } from 'react';

import InventoryAssetTreeTransfer from '@atom/components/common/inventoryAssetTreeTransfer/InventoryAssetTreeTransfer';
import ReplaceElementModalContext from '@atom/components/common/replaceElement/ReplaceElementModalContext';
import {
  CategoryPathItem,
  InventoryAssetDetailType,
  SearchAssetWithElements,
} from '@atom/types/inventory';

import classes from './replaceElement.module.css';

interface Props {
  handleReplacementAssetClick: (
    asset: InventoryAssetDetailType | SearchAssetWithElements,
    path: CategoryPathItem[],
  ) => void;
}

const ReplacementStep = ({ handleReplacementAssetClick }: Props) => {
  const { element, rootAsset } = useContext(ReplaceElementModalContext);

  return (
    <div className={classes.listContainer}>
      <div className={classes.stepContentHeader}>
        <span>{`Choose another ${element?.assetType} to replace`}</span>
        <span className={classes.bold}>{`"${element?.name}"`}</span>
      </div>
      <InventoryAssetTreeTransfer
        filterParams={{
          schemaId: rootAsset?.schemaId,
          elementSchemaId: element?.schemaId,
        }}
        onAssetClick={handleReplacementAssetClick}
        removeAssetId={rootAsset?.id}
      />
    </div>
  );
};

export default ReplacementStep;
